module.exports = __webpack_public_path__ + "img/eye.e63338cc.svg";